import { FC } from 'react';
// components
import AccessDenied from 'components/AccessDenied';
// helper, interface, context
import { isAdmin } from 'lib/helper';
import { ChildrenType } from 'interfaces';
import { useAuthContext } from 'contexts/AuthContext';

export const AdminGuard: FC<ChildrenType> = ({ children }) => {
  const { userRoles } = useAuthContext();

  const isAdminUser = isAdmin(userRoles);

  return <>{isAdminUser ? children : <AccessDenied />}</>;
};
